import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {displayReportStatus, formatDate} from "../util/helpers";
import {toast} from "react-toastify";

export default function InsightReports() {
    const [pager, setPager] = useState();
    const [results, setResults] = useState([]);

    const [searchParams, setSearchParams] = useSearchParams();

    const page = searchParams.get("page") || "1";
    const status = searchParams.get("status") || "";
    const insightId = searchParams.get("insightId") || "";
    const reporterId = searchParams.get("reporterId") || "";

    const requestData = () => {
        const params = {page};
        if (status) params.status = status;
        if (insightId) params.insightId = insightId;
        if (reporterId) params.reporterId = reporterId;

        axios.get(`/admin/v1/insight/reports`, {params})
            .then((res) => {
                setPager(res.data);
                setResults(res.data.content || []);
            });
    };

    const setPage = (value) => {
        searchParams.set("page", value);
        setSearchParams(searchParams);
    };

    const search = () => {
        setPage(1);
        requestData();
    };

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, status, insightId, reporterId]);

    const markReviewed = (reportId) => {
        if (!window.confirm("신고 상태를 검토 완료로 변경하시겠습니까?")) {
            return;
        }
        axios.patch(`/admin/v1/insight/reports/${reportId}/review`)
            .then(() => {
                toast.success("신고 상태가 업데이트되었습니다.");
                requestData();
            });
    };

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: "0px"}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">콘텐츠관리 &gt; 신고 게시글</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: "40px"}}>
                                            <div className="form-group row" style={{float: "right"}}>
                                                <label className="col-sm-auto col-form-label" style={{marginLeft: "10px"}}>게시글 ID</label>
                                                <input
                                                    type="text"
                                                    className="form-control float-right"
                                                    style={{width: "140px", marginRight: "20px"}}
                                                    placeholder="게시글 ID"
                                                    value={insightId}
                                                    onChange={(e) => {
                                                        searchParams.set("page", "1");
                                                        searchParams.set("insightId", e.target.value);
                                                        setSearchParams(searchParams);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            search();
                                                        }
                                                    }}
                                                />

                                                <label className="col-sm-auto col-form-label" style={{marginLeft: "10px"}}>신고자 ID</label>
                                                <input
                                                    type="text"
                                                    className="form-control float-right"
                                                    style={{width: "140px", marginRight: "20px"}}
                                                    placeholder="신고자 ID"
                                                    value={reporterId}
                                                    onChange={(e) => {
                                                        searchParams.set("page", "1");
                                                        searchParams.set("reporterId", e.target.value);
                                                        setSearchParams(searchParams);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            search();
                                                        }
                                                    }}
                                                />

                                                <label className="col-sm-auto col-form-label" style={{marginLeft: "10px"}}>상태</label>
                                                <select
                                                    className="form-control float-right"
                                                    style={{width: "150px", marginRight: "20px"}}
                                                    value={status}
                                                    onChange={(e) => {
                                                        searchParams.set("page", "1");
                                                        searchParams.set("status", e.target.value);
                                                        setSearchParams(searchParams);
                                                    }}
                                                >
                                                    <option value="">전체</option>
                                                    <option value="PENDING">검토 대기</option>
                                                    <option value="REVIEWED">검토 완료</option>
                                                </select>

                                                <button
                                                    type="button"
                                                    className="btn btn-info float-right"
                                                    style={{width: "80px", marginRight: "10px"}}
                                                    onClick={search}
                                                >
                                                    검색
                                                </button>
                                            </div>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{marginTop: "20px"}}>
                                            <table className="table table-hover text-nowrap" style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>신고ID</th>
                                                    <th>게시글</th>
                                                    <th>신고자</th>
                                                    <th>내용</th>
                                                    <th>상태</th>
                                                    <th>신고일</th>
                                                    <th>관리</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {results && results.map(item => (
                                                    <tr key={item.reportId}>
                                                        <td>{item.reportId}</td>
                                                        <td>
                                                            <div>
                                                                <Link to={`/page/insights/detail?id=${item.insightId}`} target="_blank" rel="noopener noreferrer">
                                                                    {item.insightId}: {item.insightTitle}
                                                                </Link>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <a
                                                                    href={`/page/users/detail?userId=${item.reporterId}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    {item.reporterId}: {item.reporterNickname || "-"}
                                                                </a>
                                                            </div>
                                                        </td>
                                                        <td style={{whiteSpace: "pre-wrap"}}>{item.description || "-"}</td>
                                                        <td>{displayReportStatus(item.status)}</td>
                                                        <td>{formatDate(item.createdAt)}</td>
                                                        <td>
                                                            {item.status === "PENDING" ? (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-success btn-sm"
                                                                    onClick={() => markReviewed(item.reportId)}
                                                                >
                                                                    검토 완료
                                                                </button>
                                                            ) : (
                                                                <span>-</span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {pager && <Pagination pager={pager} setPage={setPage} />}
                    </section>
                </div>
            </div>
        </div>
    );
}
